import React, { FC, ReactChild } from "react";

import styled from "@emotion/styled";

export const ListItem = styled.div`
    display: flex;
    padding: 0.75rem 1.25rem;
    border-top: 1px solid
        ${({ theme }) => theme.colors.grey.darken(0.5).toString()};
    border-bottom: 1px solid
        ${({ theme }) => theme.colors.grey.darken(0.5).toString()};

    & + & {
        border-top: 0;
    }

    & > * {
        flex-grow: 1;
    }
`;

export const ListItemLabel = ListItem.withComponent("label");
